import { IconProps } from '.';

const LinkedinIcon = ({ color, customClasses, ...rest }: IconProps) => {
  return (
    <svg
      className={customClasses}
      width="1em"
      height="1em"
      viewBox="0 0 27 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g clipPath="url(#clip0_8792_15005)">
        <path
          d="M24.5754 0H2.41953C1.3582 0 0.5 0.837891 0.5 1.87383V24.1211C0.5 25.157 1.3582 26 2.41953 26H24.5754C25.6367 26 26.5 25.157 26.5 24.1262V1.87383C26.5 0.837891 25.6367 0 24.5754 0ZM8.21367 22.1559H4.3543V9.74492H8.21367V22.1559ZM6.28398 8.05391C5.04492 8.05391 4.04453 7.05352 4.04453 5.81953C4.04453 4.58555 5.04492 3.58516 6.28398 3.58516C7.51797 3.58516 8.51836 4.58555 8.51836 5.81953C8.51836 7.04844 7.51797 8.05391 6.28398 8.05391ZM22.6559 22.1559H18.8016V16.123C18.8016 14.6859 18.7762 12.8324 16.7957 12.8324C14.7898 12.8324 14.4852 14.4016 14.4852 16.0215V22.1559H10.6359V9.74492H14.3328V11.441H14.3836C14.8965 10.466 16.1559 9.43516 18.0297 9.43516C21.9348 9.43516 22.6559 12.0047 22.6559 15.3461V22.1559Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_8792_15005">
          <rect
            width="26"
            height="26"
            fill="white"
            transform="translate(0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default LinkedinIcon;
